import React from 'react';

const ProgressBar = ({ progress }) => {
  const fillerStyles = {
    height: '100%',
    width: `${progress}%`,
    backgroundColor: '#42ba96', // Choose a juicy color!
    borderRadius: 'inherit',
    textAlign: 'right',
    transition: 'width 1s ease-in-out', // Smooth transition for the "juicy" feel
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: 5, // Padding to ensure the label does not touch the edges
  };

  const labelStyles = {
    padding: 5,
    color: 'white',
    fontWeight: 'bold',
    fontSize: '10px'
  };

  return (
    <div className="lite-progress-bar">
      <div style={fillerStyles}>
        <span style={labelStyles}>{`${progress}%`}</span>
      </div>
    </div>
  );
};

export default ProgressBar;
